module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Guava and Gold.fddf171b.webp";